import {Box} from '@mantine/core';
import type {FC} from 'react';
import {HOWTV_COMPANY_ADDRESS} from '../../../core/entities/shared/howtvInfo';
import {SectionTitle} from '../../../shared/components/SectionTitle';

const TEXT_CLASSNAME = 'leading-normal text-black text-base';
const TABLE_TD_CLASSNAME =
  'leading text-black-1 text-base border-black-1 border-collapse border-[1px]';

export const PmarkSignupTextComponent: FC = () => {
  return (
    <>
      <div className="section-box">
        <SectionTitle order={2} title="個人情報の取扱い" />
      </div>
      <Box className="mb-16 bg-white px-8 py-32 pc:px-32">
        <div className="mb-16">
          <p className="mb-12 text-center px-8 py-4 text-md font-bold leading-normal text-black">
            個人情報取得時の通知事項
            <br />
            会員登録における個人情報の取扱いについて
          </p>
        </div>
        <div className="mb-16">
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            1. 個人情報の適切な保護と管理者
          </p>
          <p className={TEXT_CLASSNAME}>
            弊社は、次の者を個人情報の保護管理者として任命し、
            お客様の個人情報を適切かつ安全に管理し、個人情報の漏えい、滅失又はき損を防止する保護策を講じています。
          </p>
          <br />
          <p className={TEXT_CLASSNAME}>
            株式会社ハウテレビジョン 個人情報保護管理責任者 清水 伸太郎
            <br />
            {HOWTV_COMPANY_ADDRESS}
          </p>
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            2. 個人情報の利用目的
          </p>
          <p className={TEXT_CLASSNAME}>
            お客様の個人情報は、会員情報管理、ダイレクトメール発送、スカウト配信、各種会員サービス提供のため、弊社において正当な事業遂行の範囲内で利用いたします。
            お客様がご自身の個人情報を弊社に提供されるか否かは、お客様のご判断によりますが、もしご提供されない場合には、
            適切なサービスが提供できない場合がありますので予めご了承ください。
            <br />
          </p>
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            3. 個人情報の第三者への提供
          </p>
          <p className={TEXT_CLASSNAME}>
            弊社は、次のとおり、お客様の個人データを第三者に提供する場合がございます。
          </p>
          <table className="my-12 w-full">
            <thead>
              <tr>
                <th className={TABLE_TD_CLASSNAME} scope="col">
                  情報の提供先
                </th>
                <th className={TABLE_TD_CLASSNAME} scope="col">
                  情報を提供する目的
                </th>
                <th className={TABLE_TD_CLASSNAME} scope="col">
                  提供する情報の項目・
                  <br />
                  内容
                </th>
                <th className={TABLE_TD_CLASSNAME} scope="col">
                  情報を提供する方法
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={TABLE_TD_CLASSNAME} valign="middle" width="200">
                  求人企業
                </td>
                <td className={TABLE_TD_CLASSNAME} valign="middle" width="200">
                  求人企業の採用活動のため
                </td>
                <td className={TABLE_TD_CLASSNAME} valign="middle" width="200">
                  氏名、連絡先（電話番号・メールアドレス）、学校情報・経歴・スキル、第三者のサービスにかかるアカウント情報、個人のサイト、ブログ等のURL等
                  、履歴書
                </td>
                <td className={TABLE_TD_CLASSNAME} valign="middle" width="200">
                  インターネット回線
                  <br />
                  （暗号化対応済）
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <p className={TEXT_CLASSNAME}>
            ※情報の提供先とは、守秘義務契約を締結して目的以外の利用を禁止しています。
          </p>
          <br />
          <p className={TEXT_CLASSNAME}>
            お客様の個人情報は、以下掲げる場合以外に、上記で示した以外に事前に、ご本人の同意無く第三者に提供することはありません。
          </p>
          <p className={TEXT_CLASSNAME}>(1)法令に基づく場合</p>
          <p className={TEXT_CLASSNAME}>
            (2)人の生命、身体又は財産の保護にために必要がある場合であって、本人の同意を得る事が困難であるとき
          </p>
          <p className={TEXT_CLASSNAME}>
            (3)公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得る事が困難であるとき
          </p>
          <p className={TEXT_CLASSNAME}>
            (4)国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
            本人の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがあるとき
          </p>

          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            4. 個人情報の取扱業務の委託
          </p>
          <p className={TEXT_CLASSNAME}>
            個人情報の取扱業務の全部または一部を外部に業務委託する場合があります。
            その際、弊社は、個人情報を適切に保護できる管理体制を敷き実行していることを条件として委託先を厳選したうえで、
            機密保持契約を委託先と締結し、お客様の個人情報を厳密に管理させます。
          </p>
          <p className="font-bold mb-12 mt-16 bg-background-1 px-8 py-4 text-md leading-normal text-black">
            5. お客様からの使用停止、削除等の申込みへの応諾
          </p>
          <p className={TEXT_CLASSNAME}>
            お客様は、弊社に対してご自身の個人情報の開示等
            （利用目的の通知、開示、内容の訂正・追加・削除、利用の停止または消去、第三者への提供の停止）に関して、当社問い合わせ窓口に申し出ることができます。
            その際、弊社はお客様ご本人を確認させていただいたうえで、合理的な期間内に対応いたします。
            なお、個人情報に関する弊社問い合わせ先は、次の通りです。
          </p>
          <div>
            <p className="mb-12 mt-16 py-4 text-md leading-normal text-black">
              株式会社ハウテレビジョン 個人情報問い合わせ窓口
            </p>
            <p className="text-sm leading-normal text-black pc:text-base">
              {HOWTV_COMPANY_ADDRESS}
            </p>
            <p className="text-sm leading-normal text-black pc:text-base">
              メールアドレス：soumu@howtelevision.jp TEL：03-6427-2862
            </p>
            <p className="text-sm leading-normal text-black pc:text-base">
              （受付時間 10:00～19:00
              ※土・日曜日、祝日、年末年始、ゴールデンウィークを除く)
            </p>
          </div>
        </div>
      </Box>
    </>
  );
};
